

// import React, { useState, useEffect } from "react";
// import {
//   FaStore,
//   FaUserFriends,
//   FaBoxOpen,
//   FaShoppingCart,
// } from "react-icons/fa";

// import Banner1 from "../imagebanner.webp";
// import Banner2 from "../imagebanner.webp";
// import Banner3 from "../imagebanner.webp";
// import Banner4 from "../imagebanner.webp";
// // import AppStore from "../images/appstore.png"
// // import GooglePlay from "../images/googleplay.png"

// const BannerCarousel = () => {
//   const banners = [
//     {
//       img: Banner1,
//       title: "Maamaas House Services",
//       desc: "Doorstep Services From Trusted Professionals",
//     },
//     {
//       img: Banner2,
//       title: "Order What You Love",
//       desc: "Fast Delivery · Best Discounts · 100% Secure",
//     },
//     {
//       img: Banner3,
//       title: "More Vendors · More Choices",
//       desc: "Verified Store Partners Ready To Serve",
//     },
//     {
//       img: Banner4,
//       title: "One App For Every Need",
//       desc: "Shop · Order · Book Appointments · Get Support",
//     },
//   ];

//   const playStoreURL =
//     "https://play.google.com/store/apps/details?id=com.maamaas.app";
//   const appStoreURL = "#";

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);

//   /* Auto Slide */
//   useEffect(() => {
//     const interval = setInterval(
//       () => setCurrentIndex((prev) => (prev + 1) % banners.length),
//       5000
//     );
//     return () => clearInterval(interval);
//   }, [banners.length]);

//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   /* Static Demo Counters */
//   const counts = {
//     users: 1200,
//     vendors: 85,
//     products: 160,
//     totalOrders: 980,
//   };

//   const styles = {
//     counterRow: {
//       position: "absolute",
//       bottom: "23px",
//       left: "50%",
//       transform: "translateX(-50%)",
//       display: "grid",
//       gridTemplateColumns: "repeat(4, 1fr)",
//       gap: "15px",
//       padding: "10px 15px",
//       borderRadius: "15px",
//       zIndex: 5,
//       width: "100%",
//       maxWidth: "900px",
//       textAlign: "center",
//     },
//     counterNumber: { fontSize: "35px", fontWeight: "bold", margin: 0, color: "#fff" },
//     counterText: { fontSize: "17px", marginTop: 5, color: "#fff" },
//     icon: { fontSize: "32px", color: "#fff", marginBottom: 5 },
//   };

//   return (
//     <div style={{ width: "100%", position: "relative", fontFamily: "'Poppins', sans-serif" }}>
//       <div style={{ position: "relative", overflow: "hidden" }}>

//         {/* Overlay: stronger for better text readability */}
//         <div
//           style={{
//             position: "absolute",
//             inset: 0,
//             background: "linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.5))",
//             zIndex: 2,
//           }}
//         ></div>

//         {/* Slider */}
//         <div
//           style={{
//             display: "flex",
//             transition: "transform 0.7s ease-in-out",
//             transform: `translateX(-${currentIndex * 100}%)`,
//           }}
//         >
//           {banners.map((b, index) => (
//             <img
//               key={index}
//               src={b.img}
//               alt={`banner-${index}`}
//               style={{
//                 flexShrink: 0,
//                 width: "100%",
//                 height: windowWidth <= 768 ? "420px" : "720px",
//                 objectFit: "cover",
//               }}
//             />
//           ))}
//         </div>

//         {/* Text Block */}
//         <div
//           style={{
//             position: "absolute",
//             top: windowWidth <= 768 ? "24%" : "35%",
//             left: windowWidth <= 768 ? "15px" : "40px",
//             zIndex: 5,
//             maxWidth: "550px",
//             color: "#fff",
//           }}
//         >
//           <h1
//             style={{
//               fontSize: windowWidth <= 768 ? "1.9rem" : "3.3rem",
//               fontWeight: "bold",
//               textShadow: "2px 2px 6px #000",
//               marginBottom: "8px",
//             }}
//           >
//             {banners[currentIndex].title}
//           </h1>
//           <p
//             style={{
//               fontSize: windowWidth <= 768 ? "1rem" : "1.4rem",
//               textShadow: "1px 1px 4px #000",
//               marginBottom: "25px",
//             }}
//           >
//             {banners[currentIndex].desc}
//           </p>

//           {/* STORE BUTTONS */}
//           <div style={{
//             display: "flex",
//             gap: "10px",
//             flexWrap: "wrap",
//             alignItems: "center"
//           }}>
//             <img
//               onClick={() => window.open(appStoreURL, '_blank', 'noopener,noreferrer')}
//               src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
//               alt="Download on the App Store"
//               style={{
//                 height: window.innerWidth < 500 ? "25px" : "50px",
//                 cursor: "pointer",
//                 width: "auto",
//                 objectFit: "contain"
//               }}
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = "https://upload.wikimedia.org/wikipedia/commons/6/67/Download_on_the_App_Store_Badge.svg";
//               }}
//             />
//             <img
//               onClick={() => window.open(playStoreURL, '_blank', 'noopener,noreferrer')}
//               src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
//               alt="Get it on Google Play"
//               style={{
//                 height: window.innerWidth < 500 ? "35px" : "75px",
//                 cursor: "pointer",
//                 width: "auto",
//                 objectFit: "contain"
//               }}
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = "https://upload.wikimedia.org/wikipedia/commons/c/cd/Get_it_on_Google_play.svg";
//               }}
//             />
//           </div>
//         </div>

//         {/* COUNTERS BLOCK */}
//         <div style={styles.counterRow} className="counter-row">
//           <div>
//             <FaUserFriends style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.users}+</h2>
//             <p style={styles.counterText}>Users</p>
//           </div>

//           <div>
//             <FaStore style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.vendors}+</h2>
//             <p style={styles.counterText}>Partners</p>
//           </div>

//           <div>
//             <FaBoxOpen style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.products}+</h2>
//             <p style={styles.counterText}>Products</p>
//           </div>

//           <div>
//             <FaShoppingCart style={styles.icon} />
//             <h2 style={styles.counterNumber}>{counts.totalOrders}+</h2>
//             <p style={styles.counterText}>Total Orders</p>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Responsive Fix */}
//       <style>
//         {`
//           @media(max-width: 768px) {
//             .counter-row {
//               grid-template-columns: repeat(4, 1fr) !important;
//               gap: 6px !important;
//               padding: 4px !important;
//             }
//             .counter-number { font-size: 18px !important; }
//             .counter-text { font-size: 10px !important; }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default BannerCarousel;



import React, { useState, useEffect } from "react";
import {
  FaStore,
  FaUserFriends,
  FaBoxOpen,
  FaShoppingCart,
} from "react-icons/fa";
import axios from "axios";
import Banner1 from "../top-view-bowls-with-indian-food.jpg";
import Banner3 from "../closeup-shot-restaurant-menu-set-black-plates-perfect-food-background.jpg";
import Banner2 from "../buffet-6329757_1280.jpg";
import Banner4 from "../top-view-table-full-delicious-food-composition.jpg";

const BannerCarousel = () => {
  const banners = [
    {
      img: Banner1,
      title: "Maamaas House Services",
      desc: "Doorstep Services From Trusted Professionals",
    },
    {
      img: Banner2,
      title: "Order What You Love",
      desc: "Fast Delivery · Best Discounts · 100% Secure",
    },
    {
      img: Banner3,
      title: "More Vendors · More Choices",
      desc: "Verified Store Partners Ready To Serve",
    },
    {
      img: Banner4,
      title: "One App For Every Need",
      desc: "Shop · Order · Book Appointments · Get Support",
    },
  ];

  const playStoreURL =
    "https://play.google.com/store/apps/details?id=com.maamaas.app";
  const appStoreURL = "#";

  const [currentIndex, setCurrentIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [counts, setCounts] = useState({
    users: 0,
    vendors: 1,
    products: 0,
    totalOrders: 0,
  });
  const [loading, setLoading] = useState(true);

  // Fetch statistics from APIs
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        
        if (!token || !vendorId) {
          console.error("No token or vendorId found");
          setLoading(false);
          return;
        }

        const headers = { Authorization: `Bearer ${token}` };

        // Fetch multiple data sources in parallel
        const [statsResponse, dishesResponse] = await Promise.all([
          // Fetch order statistics
          axios.get(
            `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
            { headers }
          ),
          // Fetch dishes data
          axios.get(
            `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
            { headers }
          )
        ]);

        const stats = statsResponse.data;
        const dishes = dishesResponse.data || [];

        // Count dishes with parentId = 1
        const dishesWithParentId1 =  dishes.filter(dish => dish.parentId !== 0);;
        const productsCount = dishesWithParentId1.length;

        // Update counts with real data from APIs
        setCounts({
          users: stats.totalCustomers || 0, // From statistics API
          vendors: 1, // Fixed as 1 for current vendor
          products: productsCount, // Count from dishes API
          totalOrders: stats.totalOrders || 0, // From statistics API
        });

    

      } catch (error) {
        console.error("Error fetching data:", error);
        
        // Log detailed error information
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error status:", error.response.status);
        }
        
        // Fallback: Use demo data if API fails
        setCounts({
          users: 1200,
          vendors: 1,
          products: 160,
          totalOrders: 980,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
    
    // Optional: Refresh data every 5 minutes
    const intervalId = setInterval(fetchAllData, 5 * 60 * 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  /* Auto Slide */
  useEffect(() => {
    const interval = setInterval(
      () => setCurrentIndex((prev) => (prev + 1) % banners.length),
      5000
    );
    return () => clearInterval(interval);
  }, [banners.length]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Format number with commas and plus sign
  const formatNumber = (num) => {
    if (typeof num !== 'number') return '0+';
    return `${num.toLocaleString()}+`;
  };

  const styles = {
    counterRow: {
      position: "absolute",
      bottom: "23px",
      left: "50%",
      transform: "translateX(-50%)",
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "15px",
      padding: "10px 15px",
      borderRadius: "15px",
      zIndex: 5,
      width: "100%",
      maxWidth: "900px",
      textAlign: "center",
    },
    counterNumber: { 
      fontSize: "35px", 
      fontWeight: "bold", 
      margin: 0, 
      color: "#fff",
      minHeight: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    counterText: { fontSize: "17px", marginTop: 5, color: "#fff" },
    icon: { fontSize: "32px", color: "#fff", marginBottom: 5 },
  };

  return (
    <div style={{ width: "100%", position: "relative", fontFamily: "'Poppins', sans-serif" }}>
      <div style={{ position: "relative", overflow: "hidden" }}>

        {/* Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0.5))",
            zIndex: 2,
          }}
        ></div>

        {/* Slider */}
        <div
          style={{
            display: "flex",
            transition: "transform 0.7s ease-in-out",
            transform: `translateX(-${currentIndex * 100}%)`,
          }}
        >
          {banners.map((b, index) => (
            <img
              key={index}
              src={b.img}
              alt={`banner-${index}`}
              style={{
                flexShrink: 0,
                width: "100%",
                height: windowWidth <= 768 ? "420px" : "720px",
                objectFit: "cover",
              }}
            />
          ))}
        </div>

        {/* Text Block */}
        <div
          style={{
            position: "absolute",
            top: windowWidth <= 768 ? "24%" : "35%",
            left: windowWidth <= 768 ? "15px" : "40px",
            zIndex: 5,
            maxWidth: "550px",
            color: "#fff",
          }}
        >
          <h1
            style={{
              fontSize: windowWidth <= 768 ? "1.9rem" : "3.3rem",
              fontWeight: "bold",
              textShadow: "2px 2px 6px #000",
              marginBottom: "8px",
            }}
          >
            {banners[currentIndex].title}
          </h1>
          <p
            style={{
              fontSize: windowWidth <= 768 ? "1rem" : "1.4rem",
              textShadow: "1px 1px 4px #000",
              marginBottom: "25px",
            }}
          >
            {banners[currentIndex].desc}
          </p>

          {/* STORE BUTTONS */}
          <div style={{
            display: "flex",
            gap: "10px",
            flexWrap: "wrap",
            alignItems: "center"
          }}>
            <img
              onClick={() => window.open(appStoreURL, '_blank', 'noopener,noreferrer')}
              src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
              alt="Download on the App Store"
              style={{
                height: window.innerWidth < 500 ? "25px" : "50px",
                cursor: "pointer",
                width: "auto",
                objectFit: "contain"
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://upload.wikimedia.org/wikipedia/commons/6/67/Download_on_the_App_Store_Badge.svg";
              }}
            />
            <img
              onClick={() => window.open(playStoreURL, '_blank', 'noopener,noreferrer')}
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              style={{
                height: window.innerWidth < 500 ? "35px" : "75px",
                cursor: "pointer",
                width: "auto",
                objectFit: "contain"
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://upload.wikimedia.org/wikipedia/commons/c/cd/Get_it_on_Google_play.svg";
              }}
            />
          </div>
        </div>

        {/* COUNTERS BLOCK */}
        <div style={styles.counterRow} className="counter-row">
          <div>
            <FaUserFriends style={styles.icon} />
            <h2 style={styles.counterNumber}>
              {loading ? "..." : formatNumber(counts.users)}
            </h2>
            <p style={styles.counterText}>Customers</p>
          </div>

          <div>
            <FaStore style={styles.icon} />
            <h2 style={styles.counterNumber}>
              {loading ? "..." : "1+"}
            </h2>
            <p style={styles.counterText}>Partners</p>
          </div>

          <div>
            <FaBoxOpen style={styles.icon} />
            <h2 style={styles.counterNumber}>
              {loading ? "..." : formatNumber(counts.products)}
            </h2>
            <p style={styles.counterText}>Products</p>
          </div>

          <div>
            <FaShoppingCart style={styles.icon} />
            <h2 style={styles.counterNumber}>
              {loading ? "..." : formatNumber(counts.totalOrders)}
            </h2>
            <p style={styles.counterText}>Total Orders</p>
          </div>
        </div>
      </div>

    

      {/* Mobile Responsive Fix */}
      <style>
        {`
          @media(max-width: 768px) {
            .counter-row {
              grid-template-columns: repeat(4, 1fr) !important;
              gap: 6px !important;
              padding: 4px !important;
            }
            .counter-number { 
              font-size: 18px !important; 
              min-height: 25px !important;
            }
            .counter-text { 
              font-size: 10px !important; 
              margin-top: 2px !important;
            }
          }
          
          @media(max-width: 480px) {
            .counter-number { 
              font-size: 16px !important; 
            }
            .counter-text { 
              font-size: 9px !important; 
            }
          }
        `}
      </style>
    </div>
  );
};

export default BannerCarousel;